import { useCallback, useState, useRef } from 'react'
import styled from 'styled-components'
import { useHistory, useParams } from 'react-router-dom'
import { useForm, FormProvider } from 'react-hook-form'

import useSignupValidateCheck from 'hooks/queries/auth/useSignupValidateCheckQuery'

import TitleHeader from 'components/presenters/header/TitleHeader'
import SceneWrapper from 'components/modules/signup/SceneWrapper'
import EmailFormScene from 'components/modules/signup/EmailFormScene'
import FooterButton from 'components/modules/common/FooterButton'
import FooterBtnText from 'components/modules/signup/FooterBtnText/FooterBtnText'

const CurrScene = ({ currSceneNum, onComplete, onDuplicateCheck }) => {
  switch (currSceneNum) {
    case 1:
      return (
        <>
          <SceneWrapper padding={'calc(100vw * (45 / 375)) calc(100vw * (20 / 375))'}>
            <EmailFormScene />
          </SceneWrapper>
          <FooterButton onComplete={() => onDuplicateCheck('email')}>
            <FooterBtnText totalSceneNum={7} currSceneNum={currSceneNum} />
          </FooterButton>
        </>
      )
    case 2:
      return (
        <SceneWrapper padding={'calc(100vw * (45 / 375)) calc(100vw * (20 / 375))'}>
          asd
        </SceneWrapper>
      )
    default:
      return null
  }
}

const SingupPage = () => {
  const history = useHistory()
  const isFatching = useRef(false)
  const { redirect_path: redirectPath } = useParams()

  const [currSceneNum, setCurrSceneNum] = useState(1)
  const [totalSceneNum, setTotalSceneNum] = useState(7)
  const [validateName, setValidateName] = useState('')
  const [validateValue, setValidateValue] = useState('')

  const methods = useForm({
    defaultValues: {
      email: '',
      password: '',
      phone: '',
      sex: '',
      birth: '',
      parentCategories: [],
      detailCategories: [],
      nickname: '',
      checkList: [],
    },
  })

  const { data, isSuccess } = useSignupValidateCheck(
    { validateName, validateValue },
    {
      enabled: !!(validateName && validateValue && isFatching),
      cacheTime: 0,
      staleTIme: 0,
    },
  )

  const handleBack = useCallback(() => {
    if (currSceneNum <= 1) {
      history.goBack()
      return
    }

    setCurrSceneNum((sceneNum) => sceneNum - 1)
  }, [currSceneNum, history])

  const handleDuplicateCheck = useCallback(
    (name) => {
      const value = methods.getValues(name)
      console.log(value)
      isFatching.current = true
      setValidateName(name)
      setValidateValue(value)

      if (isSuccess) {
        isFatching.current = false
        setValidateName('')
        setValidateValue('')
      }
    },
    [methods, isSuccess],
  )

  const handleCompleteScene = useCallback(() => {
    if (totalSceneNum === currSceneNum) {
      return
    }

    setCurrSceneNum((prevSceneNum) => prevSceneNum + 1)
  }, [totalSceneNum, currSceneNum])

  const handleSubmit = useCallback(() => {}, [])

  return (
    <Wrapper>
      <HeaderBlock>
        <TitleHeader title="회원가입" onBackBtn={handleBack} />
      </HeaderBlock>
      <ContentWrapper>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            <CurrScene
              currSceneNum={currSceneNum}
              onComplete={handleCompleteScene}
              onDuplicateCheck={handleDuplicateCheck}
            />
          </form>
        </FormProvider>
      </ContentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`

const HeaderBlock = styled.div`
  width: 100%;
  height: calc(100vw * (51 / 375));
`

const ContentWrapper = styled.div`
  flex: 1 1 auto;
`

// const FooterWrapper = styled.div`
//   width: 100%;
//   height: calc(100vw * (73 / 375));
// `

// const FooterButton = styled.button`
//   background-color: #ffcf19;
//   text-align: center;
//   padding: calc(100vw * (24 / 375)) 0;
//   width: 100%;
//   height: 100%;
// `

export default SingupPage
// switch (sceneNum) {
// 	case 1:
// 		return <EmailFormScene />
// 	default:
// 		return <div>error</div>
// }
